import { Injectable } from '@angular/core';
import { ApiPrivateCruService } from 'app/armp/crud/services';

@Injectable()
export class CountryService extends ApiPrivateCruService<object> {
  resourceName(): string {
    return 'country';
  }
}
